const ProfilIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
    >
      <path
        id="Form_6"
        data-name="Form 6"
        d="M1337,398v-2a3,3,0,0,0-3-3h-8a3,3,0,0,0-3,3v2a1,1,0,1,1-2,0v-2a5,5,0,0,1,5-5h8a5,5,0,0,1,5,5v2a1,1,0,1,1-2,0Zm-12-14a5,5,0,1,1,5,5A5,5,0,0,1,1325,384Zm2,0a3,3,0,1,0,3-3A3,3,0,0,0,1327,384Z"
        transform="translate(-1321 -379)"
      />
    </svg>
  );
};

export default ProfilIcon;
